/* Manuscript theme — light interactivity */
(function () {
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function () {
    /* Mobile menu */
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.querySelector('[data-nav]');
        if (nav) nav.classList.toggle('is-open');
      });
    });

    /* Slideshows */
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('.slide'));
      if (slides.length === 0) return;
      var dotsWrap = root.querySelector('[data-dots]');
      var auto = parseInt(root.getAttribute('data-autoplay') || '6000', 10);
      var i = 0, timer;
      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, n) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to slide ' + (n + 1));
          d.addEventListener('click', function () { show(n); reset(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
        dots.forEach(function (d, x) { d.classList.toggle('on', x === i); });
      }
      function step(d) { show(i + d); reset(); }
      function reset() { if (auto > 0) { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, auto); } }
      var prev = root.querySelector('[data-prev]'); if (prev) prev.addEventListener('click', function () { step(-1); });
      var next = root.querySelector('[data-next]'); if (next) next.addEventListener('click', function () { step(1); });
      show(0); reset();
    });

    /* Quantity steppers */
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* Product: swap price when variant (size) changes */
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var data = form.querySelector('[data-variant-json]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var priceEl = document.querySelector('[data-price]');
      form.querySelectorAll('input[name="id"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var v = variants.filter(function (x) { return String(x.id) === radio.value; })[0];
          if (v && priceEl) priceEl.textContent = v.price;
        });
      });
    });
  });
})();
